import React from 'react';
import { Button, Modal, FormGroup, FormControl } from 'react-bootstrap';
import { JobDefinitionService } from '../services/JobDefinitionService';

class CreateJobDefinition extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.hideHandler = this.hideHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);
        this.createJobDefinitionHandler = this.createJobDefinitionHandler.bind(this);
        this.jobReferenceChangeHandler = this.jobReferenceChangeHandler.bind(this);
        this.getAcceptableDomains = this.getAcceptableDomains.bind(this);
        this.enteredHandler = this.enteredHandler.bind(this);
        this.state = {
            show: false,
            job_reference: "",
            jobReferenceValid: true,
        };
    }

    getAcceptableDomains() {
        var acceptableDomains = ""
        const extractionItem = this.props.extractionItem
        if (extractionItem != null && extractionItem.domains != null) {
            extractionItem.domains.forEach(function (domain) {
                acceptableDomains += domain.domain
            });
        }
        return acceptableDomains
    }

    hideHandler() {
        this.setState({ show: false, job_reference: "" });
    }

    showHandler() {
        this.setState({ show: true });
    }

    enteredHandler() {
        if (this.createJobDefinitionRef && this.createJobDefinitionRef.focus) {
            this.createJobDefinitionRef.focus();
        }
    }

    createJobDefinitionHandler() {
        // Assume this is the primary launch job if it's the first job
        var root_job = true
        if (this.state.extractionItem?.job_definitions.length > 0) {
            root_job = false
        }
        const jobDef = {
            job_reference: this.state.job_reference,
            extraction_id: this.props.extraction.id,
            root_job: root_job,
            script: "",
            last_test_input: "",
            last_test_url: "",
            last_test_data: "",
            last_test_output: "",
            last_gen_schema_options: "",
            last_test_unique_key: "",   
            last_test_folder_name: "",
            render_type: JobDefinitionService.PLAYWRIGHT_RENDER_TYPE,
            sample_percent: 100,
            store_output_as_file: false,
            special_flags: 0,
            job_urls: [],
            urls_to_delete: []
        }
        this.props.jobDefinitionService.updateJobDefinition(jobDef)
        .then(result => {
            const { jobDefinition, status, errorMessage } = result;
            this.setState({ 
                errorMessage: errorMessage,
                jobReferenceValid: (errorMessage == null)
            });
            if (!errorMessage && status == "created") {
                this.props.onJobDefinitionCreated(jobDefinition);
                this.hideHandler();
            }
        })
        .catch(error => {
            console.error('Failed loading projects:', error);
        });
    }

    jobReferenceChangeHandler(e) {
        this.setState({ job_reference: e.target.value, jobReferenceValid: true });
    }

    render() {
        return (
            <div className="modal-container">
                <Modal
                    show={this.state.show}
                    onHide={this.hideHandler}
                    onEntered={this.enteredHandler}
                    centered
                    // aria-labelledby="contained-modal-title"
                    onKeyPress={(event) => {
                        if (event.key === "Enter") {
                            this.createJobDefinitionHandler();
                        }
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title">
                            Create a new job
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormGroup>
                            <FormControl
                                ref={(input) => (this.createJobDefinitionRef = input)}
                                type="text"
                                value={this.state.job_reference}
                                placeholder="Enter the Job Reference"
                                onChange={this.jobReferenceChangeHandler}
                                isInvalid={!this.state.jobReferenceValid}
                            />
                            <FormControl.Feedback type="invalid">
                                Please make sure the Job Reference is unique within the Extraction.
                            </FormControl.Feedback>
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.hideHandler}>
                            Cancel
                        </Button>
                        <Button variant="success" onClick={this.createJobDefinitionHandler}>
                            Create Job
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default CreateJobDefinition;